import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7a63a209"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("g", null, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M16 2.672c-7.361 0-13.328 5.968-13.328 13.328 0 7.362 5.968 13.328 13.328 13.328s13.328-5.966 13.328-13.328c0-7.361-5.968-13.328-13.328-13.328zM16 28.262c-6.761 0-12.262-5.501-12.262-12.262s5.5-12.262 12.262-12.262c6.761 0 12.262 5.501 12.262 12.262s-5.5 12.262-12.262 12.262z",
    fill: "#000000"
  }),
  /*#__PURE__*/_createElementVNode("ellipse", {
    transform: "translate(12 8)",
    cx: "4.486",
    cy: "1.525",
    rx: "1.486",
    ry: "1.525"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    transform: "translate(12 8)",
    d: "M4.479,13.325 L5.852,4.703 C5.852,4.703 5.881,4.004 5.216,4.004 C3.715,4.004 -0.074,4.008 -0.074,4.008 C-0.074,4.008 3.905,4.721 3.905,6.067 C3.905,6.067 2.597,11.827 2.597,13.357 C2.597,14.888 3.433,16.001 4.934,16.001 C6.159,16.001 7.272,14.665 7.188,12.718 C5.991,14.554 4.479,14.82 4.479,13.325 L4.479,13.325 Z"
  })
], -1))
const _hoisted_2 = [
  _hoisted_1
]

import { ref } from "vue";
import Tooltip from "@/components/tooltip.vue";


export default /*#__PURE__*/_defineComponent({
  props: {
    title: null,
    testoPopup: null,
    right: null,
    top: null
  },
  setup(__props: any) {

const props = __props as {
        title?: string;
        testoPopup?: string;
        right?: number;
        top?: number;
    }

const tooltip = ref(null);



const showPopup = () => {
    if (props.testoPopup) 
        tooltip.value.show();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(Tooltip, {
      ref_key: "tooltip",
      ref: tooltip,
      text: __props.testoPopup,
      style: _normalizeStyle([{"position":"absolute"}, {right: __props.right ? (__props.right + 'px') : '24px', top: __props.top ? (__props.top + 'px') : '-20px'}])
    }, null, 8, ["text", "style"]),
    _createElementVNode("svg", {
      viewBox: "0 0 30 30",
      focusable: "false",
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      class: "webinsInfoIcon",
      onClick: showPopup
    }, _hoisted_2)
  ]))
}
}

})